// extracted by mini-css-extract-plugin
export var closeButton = "_kn-1";
export var closeX = "_kn-3";
export var container = "_kn-0";
export var image = "_kn-2";